export const SpaceShuffleButtonSize = 40;
